/** Base URL of the Waypoint API (shared by the axios client and the token refresher). */
export const API_BASE_URL: string =
  (import.meta as unknown as Record<string, Record<string, string>>).env?.VITE_API_BASE_URL ||
  'http://localhost:3000/api/v1';
